import React from 'react';

import {connect} from "react-redux";
import Loader from "../common/Loader";
import sematable, {Table} from "sematable";
import {Button, NavItem} from "react-materialize";
import l10n from "../../l10n/localization";
import UnderwriterTabs from "../underwriter/UnderwriterTabs";
import * as creationActions from "../../actions/creation";
import * as underwriterActions from "../../actions/underwriter";
import Dropdown from "../common/Dropdown";
import Dialog from "react-toolbox/lib/dialog/Dialog";

export const UNDERWRITERS_TABLE = 'UNDERWRITERS_TABLE';

const columns = [
    { key: 'id', header: 'ID', primaryKey: true, hidden: true},
    { key: 'name', header: l10n.underwriter.name, searchable: true, filterable: true, sortable: true},
    { key: 'rebateRate', header: l10n.underwriter.rebateRate, searchable: true, sortable: true},
    { key: 'countryName', header: l10n.underwriter.country, searchable: true, filterable: true, sortable: true},
    { key: 'actions', header: ''}
];

/**
 * Table
 */
class UnderwritersTable extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            underwriterID: null,
            dialogActive: false
        };
    }

    handleDelete = () =>{
        this.props.dispatch(underwriterActions.deleteUnderwriter(this.state.underwriterID));
    };

    addActions() {
        this.props.columns[this.props.columns.length - 1].Component = ({row}) => {
            return (
                <div className="fog-table-buttons">
                    <Button floating onClick={() => this.props.handleClick(UnderwriterTabs, {item: row}, creationActions.destroyingnewlyCreatedUnderwriter())} icon="edit" className="edit-button" />
                    {<Dropdown trigger={(props) => (
                        <Button floating icon="more_vert" className="more-button" onClick={props.onClick}/>)}>
                        <NavItem>
                            <Button disabled={this.props.deletingUnderwriter} className="transparent" onClick={() => this.setState({...this.state, dialogActive: true, underwriterID: row.id})} >
                                {l10n.common.remove}
                            </Button>
                        </NavItem>
                    </Dropdown>}
                </div>
            );
        };
    }

    render() {
        this.addActions();

        return (
            <div>
                <Table  {...this.props} data={this.props.data} />
                <Dialog
                    actions={[
                        { label: "Cancel", onClick: () => this.setState({...this.state, dialogActive: false, underwriterID: null}) },
                        { label: "Yes", onClick: () => this.handleDelete() }
                    ]}
                    active={this.state.dialogActive}
                    title='Confirmation'>
                    <p>Are you sure you want to delete this underwriter ?</p>
                </Dialog>
            </div>
        )
    }
}

let UnderwritersTableSematable = sematable(UNDERWRITERS_TABLE, UnderwritersTable, columns, {
    defaultPageSize: -1,
    autoHidePagination: true,
    showPageSize: false
});

/**
 * Wrapper
 */
class Underwriters extends React.Component {

    componentDidMount() {
        this.props.dispatch(underwriterActions.fetchUnderwriters(true));
    }

    render() {
        if (this.props.loading || this.props.underwriters === undefined) {
            return (<div><Loader/></div>)
        }

        return (
            <div>
                <h1>{this.props.item.title}</h1>
                <Button type="button" floating onClick={() => this.props.handleClick(UnderwriterTabs, {item: null, selectNewItem: false}, creationActions.destroyingnewlyCreatedUnderwriter())} icon="add" className="add-button"/>
                <UnderwritersTableSematable {...this.props} data={this.props.underwriters} />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        underwriters: state.underwriter.underwriters,
        loading: state.underwriter.loading,
    });
})(Underwriters);


// WEBPACK FOOTER //
// ./src/components/prefTables/Underwriters.js